import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import Snackbar from '@mui/material/Snackbar';
import {Icon} from '@mui/material';
import {IconButton} from '@mui/material';
import {orange, grey, green} from '@mui/material/colors';


const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	},
	snackbar: {
		width: '600px', 
		[theme.breakpoints.down('md')]: {
		  width: '100%',
		},
	},
	snackbarContent: {
		width: '100%',
		backgroundColor: green[500] + ' !important', 
		color: grey[100] + ' !important',
	},
	snackbarWarningContent: {
		width: '100%',
		backgroundColor: orange[500],
		color: 'black',
		
	},
	detailsButton: {
		marginTop: theme.spacing(0.25),
		color: grey[100]
	},
	close: {
		width: theme.spacing( 4),
		height: theme.spacing( 4)
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	autoHideDuration?: number;
	isWarning?: boolean;
	message?: string;
	onClose?: Function;
}

type State = {
	open: boolean;
};

class SuccessView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
        super(props, {});
        if(props.message){
		    this.state = { open: true };
        } else  {
		    this.state = { open: false };
        }
	}

	UNSAFE_componentWillReceiveProps(props: any) {
		if (props.message) {
			this.setState({ open: true });
		}
	}
	componentDidMount() {
		const { props } = this;
		if (props.message) {
			this.setState({ open: true });
		}
	}

	handleClose = (event: any) => {
		this.setState({ open: false });
		if (this.props.onClose) {
			this.props.onClose();
		}
	};

	handleCloseRequest = (event: any, reason: string) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ open: false });
		if (this.props.onClose) {
			this.props.onClose();
		}
	};

	render() {
		const { classes }: { classes: ClassNameMap } = this.props;
		const { message, autoHideDuration } = this.props;
		const { open } = this.state;

        var action: any;
		if (!message) {
			return null;
		}
		action = [
			<IconButton
				key="close"
				aria-label="Close"
				color="inherit"
				className={classes.close}
				onClick={this.handleClose}
				size="large"
			>
				<Icon>close</Icon>
			</IconButton>
		];

		// TODO: jdouglas - Toastr based implementation for IE 10?
		
		return (
			<div id="success-view" className={classes.container}>
				<Snackbar 
					className={classes.snackbar}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'center'
					}}
					open={open}
					autoHideDuration={autoHideDuration !== undefined ? autoHideDuration : 5000}
					ContentProps={{
						'aria-describedby': 'message-id',
						className: !this.props.isWarning ? classes.snackbarContent : classes.snackbarWarningContent
					}}
					onClose={this.handleCloseRequest}
					message={<span id="message-id">{message}</span>}
					action={action}
				/>
			</div>
		);
	}
}

export default withStyles(styles)(SuccessView);
